import { Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React from "react";
import { useSelector } from "react-redux";
import "./Data.css";
export default function AnalyzeTable() {
    //debugger;
    const state = useSelector((store) => store.analyze);
   const { showChart, multiLineChartDataPrepared,tableData,selectedDataPoints,tableDataPrepared } = state;


    const { periods, seriesData } = multiLineChartDataPrepared;

//     let selectedData = tableData?.filter((row) =>
//     selectedDataPoints?.includes(row.dataSourceID)
//   );

 // let selectedDataSources = selectedData.map((row) => row.dataSourceName);

//     let filteredSeries = seriesData.filter((series) =>
//     selectedDataSources.includes(series.name)
//   );    
   const { rows, columns } = tableDataPrepared;

   return (
      <Box sx={{ display: showChart ? "none" : "block" }}>
         <DataGrid
            disableColumnMenu
            sx={{ maxHeight: "50vh", "& .MuiDataGrid-cell": { border: "1px solid #000" } }}
            rows={rows}
            columns={columns}
            disableSelectionOnClick
            slots={{
               SelectedRowCount:()=>null,
            }}
            getCellClassName={(params) => (params.field==='col1'?'frozen-cell':'')}
            getColumnHeaderClassName={(params) => params.field==='col1'?'frozen-header':''}
         ></DataGrid>
      </Box>
   
   );
}
